

















































import Vue from 'vue'
import { Emit, Prop } from 'vue-property-decorator'
import { Component } from '@niknevis/vue-modules'

export enum NotifType {
  SUCCESS = 'success',
  WARNING = 'warning',
  INFO = 'info',
}

@Component
export default class AlertNotification extends Vue {
  @Prop([Boolean]) value: boolean | undefined
  @Prop({ default: true }) closeButton: boolean | undefined
  @Prop({ default: NotifType.SUCCESS }) type!: NotifType | string
  @Prop() textColor!: string
  @Prop() hexColor!: string
  @Prop() hexBgColor!: string

  notifType = NotifType

  @Emit('input')
  updateValue() {
    return !this.value
  }

  get isSlotDefault() {
    return this.$scopedSlots.default
  }

  get setType() {
    const type = this.type
    if (type === 'success') {
      return {
        border: 'border-green',
        iconBg: 'bg-tes-green',
        icon: 'tes-green',
        background: 'bg-tes-green-more-transparent',
        listStyle: (this.textColor) ? 'text-' + this.textColor : 'text-tes-green'
      }
    } else if (type === 'warning') {
      return {
        border: 'border-orange',
        iconBg: 'bg-tes-orange',
        icon: 'tes-orange',
        background: 'bg-tes-orange-lighter',
        listStyle: (this.textColor) ? 'text-' + this.textColor : 'text-tes-orange'
      }
    } else if (type === 'info') {
      return {
        border: 'border-blue',
        iconBg: 'bg-tes-blue',
        icon: 'tes-blue',
        background: 'bg-tes-blue-light',
        listStyle: (this.textColor) ? 'text-' + this.textColor : 'text-tes-navy-blue-darker'
      }
    }
  }

}
